import { gql } from 'apollo-boost'

const START_PROBING_SESSION = gql`
  mutation startProbingSession($type: MenuProbingSessionType!) {
    startProbingSession(type: $type) {
      id
    }
  }
`

export default START_PROBING_SESSION
